import React from "react";
import { Reveal, Overline } from "./Reveal";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { FAQ as FAQ_DATA } from "../lib/data";

export const FAQ = () => (
  <section id="faq" data-testid="faq" className="border-t border-line bg-surface">
    <div className="max-w-[1400px] mx-auto px-5 sm:px-8 py-24 sm:py-36 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
      <div className="lg:col-span-4">
        <Reveal><Overline>Questions</Overline></Reveal>
        <Reveal delay={0.05}>
          <h2 className="font-serif font-light text-4xl sm:text-5xl tracking-tight mt-6 leading-[1.05] sticky top-28">
            Everything you need to know before you apply.
          </h2>
        </Reveal>
      </div>

      <div className="lg:col-span-8">
        <Reveal>
          <Accordion type="single" collapsible className="w-full">
            {FAQ_DATA.map((item, i) => (
              <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-item-${i}`} className="border-line">
                <AccordionTrigger className="font-serif text-xl sm:text-2xl text-bone hover:text-brass hover:no-underline text-left py-7">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="text-mute text-base leading-relaxed pb-7">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </div>
  </section>
);
